/**
 * 有効な修理データの件数をカウントする関数
 * @param {Array} repairData - 修理データの配列
 * @returns {number} - 有効な修理回数
 */
export function countValidRepairs(repairData) {
  if (!Array.isArray(repairData)) return 0;

  return repairData.filter(r =>
    r && typeof r === 'object' &&
    Object.values(r).some(v => Array.isArray(v) ? v.length > 0 : !!v)
  ).length;
}

/**
 * 同様にクリーニングデータにも使える関数（必要なら汎用化）
 */
export function countValidCleaning(cleaningData) {
  if (!Array.isArray(cleaningData)) return 0;

  return cleaningData.filter(c =>
    c && typeof c === 'object' &&
    Object.values(c).some(v => Array.isArray(v) ? v.length > 0 : !!v)
  ).length;
}
